//
import { ColumnDef } from "@tanstack/react-table"
// import { TransferProps } from "./resources/user.type"
import moment from "moment"
//
import { ChipStyled } from "src/shared/components"
import { capitalizeFirstLetter } from "src/shared/utils/data-helpers"
import { IconButton, Tooltip } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"

export const getLocationListTableColumns = ({
  onEdit,
  hasPermission
}: {
  onEdit?: (location: any) => void
  hasPermission: (permission: string) => boolean
}): ColumnDef<any, any>[] => {
  return [
    {
      header: "ID",
      accessorKey: "secondaryId"
    },
    {
      header: "Name",
      accessorKey: "name"
    },
    {
      header: "Area",
      accessorKey: "area"
    },
    {
      header: "Linked Warehouse",
      accessorKey: "warehouse.name"
    },
    {
      header: "Type",
      accessorKey: "type",
      cell: ({ row }) => (
        <ChipStyled
          label={capitalizeFirstLetter((row.original.type ?? "").toString().toLowerCase())}
          size="small"
          variant="filled"
          color={(getLocationTypeColor(row.original.type) as any) ?? "default"}
        />
      )
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ row }) => (
        <ChipStyled
          label={capitalizeFirstLetter((row.original.status ?? "").toString().toLowerCase())}
          size="small"
          variant="filled"
          color={(getStatusColor(row.original.status) as any) ?? "default"}
        />
      )
    },
    {
      header: "createdAt",
      accessorKey: "createdAt",
      accessorFn: (row) => moment(row?.createdAt).format("lll")
    },
    {
      header: "Actions",
      enableHiding: false,
      meta: {
        textAlign: "center",
        headerAlign: "center",
        width: "100px"
      },
      cell: ({ row }) => (
        <Tooltip title={hasPermission("system:location:update") ? "Edit Location" : "You don't have permission"}>
          <IconButton
            disabled={!hasPermission("system:location:update")}
            onClick={() => onEdit?.(row.original)}
            size="small"
            sx={{
              color: "primary.main",
              "&:hover": {
                backgroundColor: "primary.light",
                color: "white"
              }
            }}
          >
            <EditIcon sx={{ fontSize: "16px" }} />
          </IconButton>
        </Tooltip>
      )
    }
  ]
}

const getLocationTypeColor = (type?: string) => {
  switch (type) {
    case "WAREHOUSE":
      return "primary"
    case "RETAIL":
      return "success"
    default:
      return "default"
  }
}

const getStatusColor = (status?: string) => {
  switch (status) {
    case "ACTIVE":
      return "primary"
    case "INACTIVE":
      return "warning"
    default:
      return "default"
  }
}
